import { createAction } from 'utils'

export const HYDRATE_DASHBOARD_WORKSPACE = '@dashboard/HYDRATE_WORKSPACE'
export const UPDATE_DASHBOARD_WORKSPACE = '@dashboard/UPDATE_WORKSPACE'
export const RESET_DASHBOARD_WORKSPACE_SCOPE = '@dashboard/RESET_WORKSPACE_SCOPE'
export const RESET_DASHBOARD_WORKSPACE = '@dashboard/RESET_WORKSPACE'

export const hydrateDashboardWorkspace = createAction(HYDRATE_DASHBOARD_WORKSPACE)
export const updateDashboardWorkspace = createAction(UPDATE_DASHBOARD_WORKSPACE)
export const resetDashboardWorkspaceScope = createAction(RESET_DASHBOARD_WORKSPACE_SCOPE)
export const resetDashboardWorkspace = createAction(RESET_DASHBOARD_WORKSPACE)
